import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import LatinExt from "./SpaceMono-Regular-i7dPIFZifjKcF5UAWdDRYE58RXi4EwSsbg.woff2";
import Latin from "./SpaceMono-Regular-i7dPIFZifjKcF5UAWdDRYE98RXi4EwSsbg.woff2";

export const SpaceMonoFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LatinExt,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT,
      weight: "400",
    },
  },
  {
    uri: Latin,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
    },
  },
];
